import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { memo, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import CustomSelect from 'common/shared-ui/src/components/CustomSelect';
import { LOCALES } from 'common/shared-ui/src/i18n/locales';
import GlobusIcon from 'common/shared-ui/src/icons/GlobusIcon';
import LanguageArrowIcon from 'common/shared-ui/src/icons/LanguageArrowIcon';
import LogoIconBlack from 'common/shared-ui/src/icons/LogoIconBlack';

import { useTranslation } from '../../../../packages/common/utils/getLocalString';
import { setAppLang } from '../../app/redux/reducers/userSlice';

// Original class: RightContainerRoot
const StyledRightContainerRoot = styled(Grid)(({ theme }) => ({
  selectMethod: {
    background: 'red',
  },
  [theme.breakpoints.down('md')]: {
    RightContainerRoot: {
      marginBottom: theme.spacing(3),
    },
  },
}));

const RightContainer = () => {
  const getLocalString = useTranslation();
  const dispatch = useDispatch();
  const appLang = useSelector(state => state.user.language);
  const isSmallScreen = useMediaQuery(theme =>
    theme.breakpoints.maxWidth('md'),
  );

  const langItems = useCallback(
    () =>
      Object.values({
        [LOCALES.RUSSIAN]: {
          id: LOCALES.RUSSIAN,

          name: 'Русский',
        },
        [LOCALES.ENGLISH]: {
          id: LOCALES.ENGLISH,
          name: 'English',
        },
      }),
    [],
  );

  const { current: changeLang } = useRef(e => {
    dispatch(setAppLang(e.target.value));
  });

  return (
    <StyledRightContainerRoot container direction='column' size='grow'>
      <Grid
        container
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          maxWidth: 140,
          marginLeft: 'auto',
        }}
      >
        {/* <CustomSelect
          className={classes.selectMethod}
          value={appLang}
          items={langItems()}
          handleSelect={changeLang}
          IconComponent={LanguageArrowIcon}
          label={getLocalString('labels', 'language')}
        >
          <Box width={24} height={24}>
            <GlobusIcon viewBox="0 0 24 24" />
          </Box>
        </CustomSelect> */}
      </Grid>
      <Box
        sx={{
          margin: 'auto',
          maxWidth: 242,
          display: isSmallScreen && 'none',
        }}
      >
        <Box
          sx={{
            marginBottom: 14,
          }}
        >
          <LogoIconBlack width='242' height='92' viewBox='0 0 242 92' />
        </Box>
        <Typography variant='h3'>
          {getLocalString('AuthContainer', 'description')}
        </Typography>
      </Box>
    </StyledRightContainerRoot>
  );
};

export default memo(RightContainer);
